import {Component, Input, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'article-button-box',
    templateUrl: './article-button-box.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ArticleButtonBoxComponent {
  @Input() article: string;
  @Input() workflowId: string | number;
}
